export default __webpack_public_path__ + "github-copilot.dc8a5752.png";